import { PermissionT } from "../types";

export const financeManagementReadOnly = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "finance_management_read_only");
  return !!p;
};

export default financeManagementReadOnly;
